 
 

  import { Box, Typography, Divider } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import "./CategoryChart.css";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CategoryChart({ data }) {
  const keys = [
    "Yaxıt və maye məhsulları",
    "Avtomobil aksesuarları",
    "Avtomobil hissələri / ehtiyat hissələri",
    "Xüsusi məhsullar / Digər"
  ];

  const colors = ["#845ADF", "#23B7E5", "#CEC92F", "#26BF94"];

  const values = data && data.length > 0 ? Object.values(data[0]) : [0,0,0,0];

  const total = values.reduce((a, b) => a + b, 0);

  const chartData = {
    labels: keys,
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 0,
        borderSkipped: false,
        borderRadius: ({ dataset, index }) => {
          const value = dataset.data[index];
          return value / total * 100;
        },
      },
    ],
  };

 

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "85%",
    plugins: { legend: { display: false } }, 
  };

  return (
    <Box className="category-chart-box">
      <Typography className="chart-title">Kateqoriya çeşidliliyi</Typography>

      <Divider sx={{ my: 1 }} />

      <Box className="chart-wrapper">
        <Doughnut data={chartData} options={options} />

        <Box className="chart-center">
          <Typography className="chart-center-title">Toplam</Typography>
          <Typography className="chart-center-value">{total}</Typography>
        </Box>
      </Box>

      <Box className="chart-legend-horizontal">
        {keys.map((name, idx) => (
          <Box key={idx} className="legend-item">
            <span
              className="legend-number"
              style={{ backgroundColor: colors[idx] }}
            ></span>
            <Box className="legend-text">
              <Typography className="legend-name">{name}</Typography>
              <Typography className="legend-value">{values[idx]}</Typography>
            </Box>
          </Box>
        ))}
      </Box>

    </Box>
  );
}
